exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body>div,body>div>div{height:100%}body>#ads,body>.calendar-month-view,body>.crisp-client{height:0}body>.sweet-alert{height:auto}body>.toast-top-right{margin-top:70px;height:auto}body>.webui-popover,body>.webui-popover-inner{height:auto}body>#_elev_io{height:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6a2576f5","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/panel/panel.vue
// module id = 1103
// module chunks = 0